<!-- eslint-disable no-unsafe-optional-chaining -->
<!-- eslint-disable vue/html-self-closing -->
<template>
  <div class="gf-multi-file-uploader">
    <!-- инпут с итоговыми данными -->
    <input
      :id="uploaderId"
      ref="filesList"
      class="d-none"
      type="file"
      :name="uploaderName"
      :accept="allowedExtentions"
      :required="required"
      multiple
    />
    <label
      ref="uploader"
      class="gf-multi-file-uploader__uploader mb-0"
      for="uploader"
      @drop.prevent="onDrop"
      @dragover.prevent="onDragOver"
      @dragleave.prevent="onDragLeave"
    >
      <!-- инпут для добавления файлов -->
      <input
        id="uploader"
        ref="inputUploader"
        type="file"
        :accept="allowedExtentions"
        multiple
        @change="onUploaderInputChange"
      />
      <h2 class="d-flex align-items-center justify-content-center">
        <i class="gf-icon gf-icon-upload gf-fs-6"></i>
      </h2>
      <b>Кликните или перенесите файлы для загрузки</b>
      <br />
      <span v-if="allowedExtentions">{{ allowedExtentions?.split(',')?.join(' ') }}</span>
    </label>
    <div
      v-if="files?.length > 0"
      class="gf-multi-file-uploader__files mt-3"
    >
      <gf-custom-multi-file-uploader-item
        v-for="(file, index) in files"
        :key="index"
        :file="file"
        @delete="onFileDelete"
      />
    </div>
    <div
      v-if="files?.length > 0"
      class="gf-multi-file-uploader__reset mt-2"
    >
      <!-- <button
        type="button"
        class="btn btn-sm btn-primary"
        @click="onResetButtonClick"
      >
        Очистить
      </button> -->
      <span>{{ formattedFilesSize }}</span>
      <button
        type="button"
        class="btn btn-sm text-secondary"
        @click="onResetButtonClick"
      >
        <i class="gf-icon gf-icon-trash"></i>
      </button>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line max-len
import GfCustomMultiFileUploaderItem from '@/shared-modules/shared-components/shared/GfCustomMultiFileUploaderItem';

export default {
  name: 'GfCustomMultiFileUploader',
  components: { GfCustomMultiFileUploaderItem },
  props: {
    uploaderId: {
      type: String,
      default: 'customUploader'
    },
    allowedExtentions: {
      type: String,
      default: ''
    },
    uploaderName: {
      type: String,
      default: 'uploaderName'
    },
    required: {
      type: Boolean,
      default: false
    },
    value: [],
    // in bytes
    maxFilesSize: {
      type: Number
    }
  },
  data() {
    return {
      files: [],
      filesList: null,
      inputUploader: null,
      uploader: null,
      filesSize: 0
    };
  },
  computed: {
    formattedFilesSize() {
      let filesSize = 0;
      this.files?.forEach((file) => {
        // eslint-disable-next-line no-unsafe-optional-chaining
        filesSize += file?.size;
      });
      return this.formatBytes(filesSize);
    },
    isFilesSizeExceedsMaxSize() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.filesSize = 0;
      this.files?.forEach((file) => {
        // eslint-disable-next-line no-unsafe-optional-chaining
        this.filesSize += file?.size;
      });
      return this.filesSize > this.maxFilesSize;
    }
  },
  mounted() {
    this.filesList = this.$refs.filesList;
    this.inputUploader = this.$refs.inputUploader;
    this.uploader = this.$refs.uploader;
  },
  methods: {
    onUploaderInputChange() {
      const addedFiles = Array.from(this.inputUploader.files);
      this.inputUploader.value = null;
      const newFiles = [];
      addedFiles?.forEach((file) => {
        if (!this.isFileInFilesList(file) && file.size > 0) newFiles.push(file);
      });
      this.updateFiles(newFiles);
      this.updateInputFilesList();

      // Эмитирование события в DOM для не вуйных страниц / элементов
      this.dispatchUploadedEventForNonVuePages();
    },
    dispatchUploadedEventForNonVuePages() {
      const event = new CustomEvent('GfCustomFileUploaderUploadedEvent', {
        detail: { message: 'UPLOADED' }
      });
      document.dispatchEvent(event);
    },
    dispatchResetEventForNonVuePages() {
      const event = new CustomEvent('GfCustomFileUploaderResetEvent', {
        detail: { message: 'RESET' }
      });
      document.dispatchEvent(event);
    },
    onDrop(e) {
      this.onDragLeave();
      const droppedFiles = Array.from(e.dataTransfer.files);
      const newFiles = [];
      droppedFiles?.forEach((file) => {
        if (!this.isFileInFilesList(file)) newFiles.push(file);
      });
      this.updateFiles(newFiles);
      this.updateInputFilesList();
      this.dispatchUploadedEventForNonVuePages();
    },
    onDragOver() {
      this.uploader.classList.add('--dragenter');
    },
    onDragLeave() {
      this.uploader.classList.remove('--dragenter');
    },
    onFileDelete(fileToDelete) {
      const indexToDelete = this.files.indexOf(fileToDelete);
      this.files.splice(indexToDelete, 1);
      this.updateInputFilesList();
      if (this.files.length === 0) this.dispatchResetEventForNonVuePages();
    },
    onResetButtonClick(e) {
      e.preventDefault();
      this.resetFiles();
    },
    resetFiles() {
      this.filesList.value = '';
      this.inputUploader.value = '';
      this.files = [];
      this.emitData();
      this.dispatchResetEventForNonVuePages();
    },
    updateFiles(newFiles) {
      newFiles?.forEach((newFile) => {
        this.files.push(newFile);
      });
    },
    updateInputFilesList() {
      const dt = new DataTransfer();
      this.files?.forEach((file) => {
        dt.items.add(file);
      });
      this.filesList.files = dt.files;
      this.emitData();
    },
    isFileInFilesList(newFile) {
      let hasDublicate = false;
      this.files?.forEach((file) => {
        if (!hasDublicate && file?.name === newFile?.name) hasDublicate = true;
      });
      return hasDublicate;
    },
    emitData() {
      if (this.maxFilesSize) {
        this.$emit('input', {
          files: this.files,
          isMaxSizeExceeded: this.isFilesSizeExceedsMaxSize
        });
      } else {
        this.$emit('input', this.files);
      }
    },
    formatBytes(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = 0;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
    }
  }
};
</script>

<style lang="scss">
$this: '.gf-multi-file-uploader';

#{$this} {
  position: relative;

  #{$this}__uploader {
    position: relative;
    width: 100%;
    padding: 16px;
    text-align: center;
    color: var(--text-muted);
    border: 2px dashed var(--border-color);
    border-radius: var(--border-radius);
    cursor: pointer;
    transition: border-color 0.15s ease-in-out;

    &:hover {
      border-color: var(--text-muted);
    }

    &.--dragenter {
      border-color: var(--text-muted);
    }
  }
  #{$this}__uploader > input[type='file'] {
    display: none;
  }
  #{$this}__files {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  #{$this}__reset {
    margin-right: 6px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>
